$(document).on('click', '.js-optional-line-item-V', (e) => {
  $('.js-optional-line-item-U').prop('checked', false)
})

$(document).on('click', '.js-optional-line-item-U', (e) => {
  $('.js-optional-line-item-V').prop('checked', false)
})
